/**
 * <epower-color-picker> shows the photo of the chosen colour and keeps the
 * choice when the product form is re-rendered after switching between direct
 * delivery and Premium Service (the picker lives inside that partial).
 */
class EpowerColorPicker extends HTMLElement {
  #ac;

  get #storageKey() {
    return `epower-color-${this.dataset.productId}`;
  }

  connectedCallback() {
    this.#ac = new AbortController();
    const saved = sessionStorage.getItem(this.#storageKey);
    if (saved) {
      const match = [...this.querySelectorAll('input[type="radio"]')].find((input) => input.value === saved);
      if (match) match.checked = true;
    }
    this.#update();
    this.addEventListener(
      'change',
      (event) => {
        if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'radio') return;
        sessionStorage.setItem(this.#storageKey, event.target.value);
        this.#update();
      },
      { signal: this.#ac.signal }
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #update() {
    const checked = this.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    const current = this.querySelector('[data-color-current]');
    if (current) current.textContent = checked.value;
    const preview = this.querySelector('[data-color-preview]');
    if (preview && checked.dataset.image) {
      preview.src = checked.dataset.image;
      preview.srcset = checked.dataset.srcset || '';
      preview.alt = checked.value;
    }
  }
}

if (!customElements.get('epower-color-picker')) {
  customElements.define('epower-color-picker', EpowerColorPicker);
}
